import { render, staticRenderFns } from "./UpdateShipment.vue?vue&type=template&id=3dc52b52&scoped=true&"
import script from "./UpdateShipment.vue?vue&type=script&lang=js&"
export * from "./UpdateShipment.vue?vue&type=script&lang=js&"
import style0 from "./UpdateShipment.vue?vue&type=style&index=0&id=3dc52b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc52b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc52b52')) {
      api.createRecord('3dc52b52', component.options)
    } else {
      api.reload('3dc52b52', component.options)
    }
    module.hot.accept("./UpdateShipment.vue?vue&type=template&id=3dc52b52&scoped=true&", function () {
      api.rerender('3dc52b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/components/UpdateShipment.vue"
export default component.exports